module.exports = __webpack_public_path__ + "static/img/systemName.150158f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/systemName.png
// module id = cF4x
// module chunks = 68